var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseFormV2',{ref:"baseForm",attrs:{"modelClass":_vm.Participant,"id":_vm.id,"beforeSaveHook":_vm.beforeSaveHook,"navigateOnSave":false},on:{"created":_vm.onCreated}})}
var staticRenderFns = []

export { render, staticRenderFns }